import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-ui-slide-toggle',
  templateUrl: './ui-slide-toggle.component.html',
  styleUrls: ['./ui-slide-toggle.component.scss'],
  standalone: false,
})
export class UiSlideToggleComponent {
  @Input() label: string;
  @Input() control: FormControl;
  @Input() required = false;
  @Input() tooltip: string;
  @Input() tooltipClass: string;

  @Output() readonly changeHandler: EventEmitter<MatSlideToggleChange> =
    new EventEmitter<MatSlideToggleChange>();

  onChange(event: MatSlideToggleChange): void {
    this.changeHandler.emit(event);
  }
}
